import { render, staticRenderFns } from "./MedicationSettings.vue?vue&type=template&id=294985fe&"
import script from "./MedicationSettings.vue?vue&type=script&lang=js&"
export * from "./MedicationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports